import { GetPaymentAccountsApi } from "@/features/accounts/payment/scraping/services/get-accounts-api";
import { GetPaymentAccountsRequestModel } from "@/features/accounts/payment/scraping/services/get-accounts-model";

/// MoneyLook 口座一覧取得処理
export class GetPaymentAccountsService {
  private getPaymentAccountsApi = new GetPaymentAccountsApi();

  /**
   * MoneyLook 口座一覧取得API実行
   */
  public async getPaymentAccounts(param: GetPaymentAccountsRequestModel) {
    return await this.getPaymentAccountsApi.getPaymentAccounts(param);
  }
}